// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require('@client-side-validations/client-side-validations')

require("jquery")
require("easy-autocomplete")
require("grapheme-splitter")
// https://github.com/danxexe/sms-counter or https://github.com/inkOfPixel/sms-length  some mess here
//  require("sms-length")

// require("foundation-datepicker")
 import("../src/foundation-datepicker")
 import("../src/promotion_datespan")
 import("../src/user_dob")

// import("../src/bundle_analyze")

require("@zxing/library")
// require("@zxing/browser")
// import("../src/qr_scan")

 // import("../src/sms")
 import("../src/sms_counter")
 import("../src/touch_table_highlight")

// import("packs/municipals")
// import flatpickr from "flatpickr"
// require("flatpicker/dist/flatpicker.css")

// document.addEventListener("turbolinks:load", () => {
//   flatpicker("[data-behavior='flatpicker']", {
//     altInput: true,
//     altFormat: "j F Y",
//     dateFormat: "Y-m-d"
//   })
// })
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
